export const COUNTRY_CODES = [{ code: "+64", label: "New Zealand (+64)" }];
export const DEFAULT_PHONE_CODE = COUNTRY_CODES[0].code;
